import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import Category from "./Category";
import Role from "./Role";
import Model from "./Model";
export class Tutorial extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Id", {
      fieldName: 'tutorial_id',
      content: null
    });
    _defineProperty(this, "TutorialId", {
      fieldName: 'tutorial_id',
      content: null
    });
    _defineProperty(this, "TutorialTitle", {
      fieldName: 'tutorial_title',
      content: null
    });
    _defineProperty(this, "TutorialDescription", {
      fieldName: 'tutorial_description',
      content: null
    });
    _defineProperty(this, "TutorialVideo", {
      fieldName: 'tutorial_video',
      content: null
    });
    _defineProperty(this, "TutorialCategory", {
      fieldName: 'tutorial_category',
      model: Category,
      content: null
    });
    _defineProperty(this, "TutorialAudience", {
      fieldName: 'tutorial_audience',
      model: Role,
      content: null
    });
    _defineProperty(this, "TutorialOnStartUp", {
      fieldName: 'on_startup',
      content: false
    });
    _defineProperty(this, "language", {
      fieldName: 'language',
      content: 'en'
    });
    _defineProperty(this, "loading", {
      content: false
    });
  }
  isLoading() {
    return this.loading.content;
  }
  startLoading() {
    this.loading.content = true;
    return this;
  }
  endLoading() {
    this.loading.content = false;
    return this;
  }
  getId() {
    return this.Id.content;
  }
  getTitle() {
    return this.TutorialTitle.content;
  }
  getVideo() {
    return this.TutorialVideo.content;
  }
  getDescription() {
    return this.TutorialDescription.content;
  }
  getYoutubeVideoEmbed() {
    var _url$searchParams$get;
    let url = new URL(this.getVideo());
    url = (_url$searchParams$get = url.searchParams.get('v')) !== null && _url$searchParams$get !== void 0 ? _url$searchParams$get : url.pathname.replace('/', '');
    return `//www.youtube.com/embed/${url}`;
  }
}
export default Tutorial;